import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as Actions from '../../../../redux/actions';
import FullWidthFinding from 'views/Components/Finding/FullWidth';
import Loading from 'views/Components/Loading';
import Logger from '../../../../lib/logger';
import {
  LabelsAndTagsFetch,
  TAG_OBJECT_TYPES,
} from 'views/Components/Label/Label';
import { getOrgUsers, withRole } from '../../../../redux/utils/users';
import {
  findingByIdSelector,
} from '../../../../selectors/findingsSelectors';

import './styles.sass';

const logger = Logger('FindingsDetailView');

const DetailView = ({
  orgId,
  fetchData,
  finding,
  findingId,
  orgUsers,
  goToFindings
}) => {
  const [currentFinding, setCurrentFinding] = useState(finding)

  const usePrevious = value => {
    const ref = useRef()
    useEffect(() => {
      ref.current = value
    })
    return ref.current
  }

  const prevOrgId = usePrevious(orgId)

  useEffect( () => {
    // if a user changes orgs, send back to findings page
    if(prevOrgId && prevOrgId !== orgId)
      goToFindings()
  }, [orgId]) /* eslint-disable-line */

  useEffect(() => {
    fetchData();
  }, [findingId, fetchData]);

  useEffect(() => {
    setCurrentFinding(finding)
  }, [finding]);

  return (
    <div className="finding-detail-view">
      <div className="content">
        {currentFinding ? (
          <LabelsAndTagsFetch
            objId={[findingId]}
            objType={[TAG_OBJECT_TYPES.FINDING]}
          >
            <FullWidthFinding finding={currentFinding} orgUsers={orgUsers} />
          </LabelsAndTagsFetch>
        ) : (
          <Loading />
        )}
      </div>
    </div>
  );
};

DetailView.propTypes = {
  findingId: PropTypes.string.isRequired,
  fetchData: PropTypes.func.isRequired,
  finding: PropTypes.shape({}),
  orgUsers: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

DetailView.defaultProps = {
  finding: null,
};

const mapStateToProps = (state, { orgId }) => {
  const { users } = state;

  const finding = findingByIdSelector(state);

  return ({
    orgId,
    finding,
    orgUsers: withRole(getOrgUsers({ usersStore: users, orgId }), 'responder')
  });
};

const mapDispatchToProps = (dispatch, { findingId, orgId }) => ({
  fetchData: () => {
    dispatch(Actions.Findings.fetchConstants());
    dispatch(Actions.User.fetchUsersForOrgWithPageActions(orgId));
    dispatch(Actions.Findings.fetchFinding(findingId))
      .then(
        () =>
          dispatch(Actions.Message.getCommentsForFinding({ findingId }))
      )
      .catch((err) => {
        logger.error(`Failed to fetch finding ${findingId}`, err);

        dispatch({
          type: 'PAGE',
          payload: {
            orgId,
            toplevel: 'reporting',
            secondlevel: 'findings',
          },
        });
      });
  },
  goToFindings: () => {
    dispatch({
      type: 'PAGE',
      payload: {
        orgId,
        toplevel: 'reporting',
        secondlevel: 'findings',
      }
    })
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DetailView);
